// src/components/MainLayout.js
import React, { useState, useEffect } from "react";
import { Layout, notification } from "antd";
import MainHeader from "./MainHeader";
import { COLORS } from "../config/theme.js";
import SideMenu from "./SideMenu";
import { getToken, onMessage } from "firebase/messaging";
import "./MainLayout.css";
import { messaging } from "../services/firebase.js";
import {
  KEY_NOTIFICATION_FIREBASE,
  // TOKEN_NOTIFICATION,
} from "../config/constants.js";
// import axios from "axios";

const MainLayout = ({ children }) => {
  const { Content, Header } = Layout;
  const [menuCollapsed, setMenuCollapsed] = useState(false);
  const [api, contextHolder] = notification.useNotification();
  useEffect(() => {
    // Verificar si las notificaciones son compatibles y si ya se ha otorgado permiso.
    if ("Notification" in window && "PushManager" in window) {
      if (Notification.permission === "granted") {
        activarMensajes();
        console.log("usuario con notificacion activada");
        // El usuario ya ha otorgado permiso para notificaciones.
      } else if (Notification.permission !== "denied") {
        // El usuario aún no ha otorgado ni denegado permiso para notificaciones.
        // Debes solicitar permiso al usuario.
        console.log(
          "El usuario aún no ha otorgado ni denegado permiso para notificaciones."
        );

        Notification.requestPermission().then((permission) => {
          if (permission === "granted") {
            // El usuario ha otorgado permiso para notificaciones.
            // Puedes mostrar notificaciones aquí si es necesario.
            activarMensajes();

            console.log(
              "/ El usuario ha otorgado permiso para notificaciones."
            );
            activarMensajes();
          } else {
            // El usuario ha denegado el permiso para notificaciones.
            // Puedes mostrar un mensaje al usuario explicando cómo habilitar notificaciones en la configuración de su dispositivo.
            console.log(
              "El usuario ha denegado el permiso para notificaciones."
            );
          }
        });
      }
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const activarMensajes = async () => {
    const token = await getToken(messaging, {
      vapidKey: KEY_NOTIFICATION_FIREBASE,
    }).catch((error) =>
      console.log("Tuviste un error al generar el token", error)
    );

    console.log("token: " + token);

    if (!token) console.log("no tienes token");
  };

  const openNotification = (message) => {
    console.log("open notification", message);
    api.info({
      message: message.notification.title,
      description: (
        <div style={{ whiteSpace: "pre-wrap", textAlign: "left" }}>
          {message.notification.body}
        </div>
      ),
      duration: 4,
    });
  };

  React.useEffect(() => {
    onMessage(messaging, (message) => {
      openNotification(message);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <Layout className="layoutContainer">
        <Header
          className="layout-admin__header"
          style={{ backgroundColor: COLORS.MAIN, color: COLORS.FONT }}
        >
          <MainHeader
            menuCollapsed={menuCollapsed}
            setMenuCollapsed={setMenuCollapsed}
          />
        </Header>
        <Layout className="layout-admin">
          <SideMenu
            menuCollapsed={menuCollapsed}
            style={{ background: "#fff" }}
          />
          <Content
            className="layout-admin__content"
            style={{
              marginLeft: "5px",
              marginRight: "0px",
              // marginTop: "10px",
              minHeight: "90vh",
            }}
          >
            {children}
          </Content>
        </Layout>
      </Layout>
      {contextHolder}
    </>
  );
};

export default MainLayout;
